<template>
    <div>
        <div v-if="(column.property_name == 'contact_type' && !column.is_custom_field && !column.is_sales_behavior)">

            <div v-if="contact.contact_types_id && residentialContactType && contact.contact_types_id === residentialContactType">
                {{ contact[column.property_name] }}
            </div>
            <select v-else v-model="contactData.selectedContactType"
                    @change="inlineUpdate(column.property_name, contactData.selectedContactType)"
                    class="appearance-none p-1 border-none focus:outline-none rounded text-grey-darkest text-xs w-full">
                    <option v-for="item in contactTypes" :value="item.id">{{ item.code }}</option>
            </select>
        </div>
        <div v-if="(column.property_name == 'contact_status' && !column.is_custom_field && !column.is_sales_behavior)">
            <select v-model="contactData.selectedContactStatus"
                    @change="inlineUpdate(column.property_name, contactData.selectedContactStatus)"
                    class="appearance-none p-1 border-none focus:outline-none rounded text-grey-darkest text-xs w-full">
                    <option v-for="item in teamContactStatuses" :value="item.id">{{ item.name }}</option>
            </select>
        </div>
        <div v-if="(column.is_custom_field && column.custom_field_type == 'TEXT')">
            <input type="text" @change="inlineUpdate(column.custom_field_id, contactData.customFields, true)" v-model="contactData.customFields.value"
            class="bg-white leading-normal tracking-wide appearance-none border-1 rounded py-1 px-2 text-grey-darkest w-full focus:outline-none">
        </div>
        <div v-if="(column.is_custom_field && (column.custom_field_type == 'DROPDOWN' || column.custom_field_type == 'USER'))">
            <select v-model="contactData.customFields.value"
                    @change="inlineUpdate(column.custom_field_id, contactData.customFields, true)"
                    class="appearance-none p-1 border-none focus:outline-none rounded text-grey-darkest text-xs w-full">
                    <option selected></option>
                    <option v-for="item in column.custom_field_options" :value="item.id">{{ item.name }}</option>
            </select>
        </div>
        <div v-if="column.is_sales_behavior">
            <datetime v-if="!calendar"
                    type="date"
                    v-model="contactData.salesBehavior.date"
                    :use-utc="true"
                    class="w-full"
                    :week-start="7"
                    :format="masks.date_mask"
                    input-class="cursor-pointer rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1"
                    @input="inlineUpdate(column.sales_behavior_id, contactData.salesBehavior, false, true)">
            </datetime>
            <datetime v-else
                    use12-hour
                    type="datetime"
                    v-model="contactData.salesBehavior.date"
                    :use-utc="true"
                    class="w-full"
                    :week-start="7"
                    :format="masks.date_time_mask"
                    :minute-step="15"
                    input-class="cursor-pointer rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1"
                    @input="inlineUpdate(column.sales_behavior_id, contactData.salesBehavior, false, true)">
            </datetime>
        </div>
        <div v-if="(column.property_name == 'date' && !column.is_custom_field && !column.is_sales_behavior)">
            <datetime v-if="!calendar"
                    type="date"
                    v-model="contactData.selectedFollowupDate"
                    :use-utc="true"
                    class="w-full"
                    :week-start="7"
                    :format="masks.date_mask"
                    input-class="cursor-pointer rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1"
                    @input="inlineUpdate(column.property_name, contactData.selectedFollowupDate, false, false, true)">
            </datetime>
            <datetime v-else
                    use12-hour
                    type="datetime"
                    v-model="contactData.selectedFollowupDate"
                    :use-utc="true"
                    class="w-full"
                    :week-start="7"
                    :format="masks.date_time_mask"
                    :minute-step="15"
                    input-class="cursor-pointer rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1"
                    @input="inlineUpdate(column.property_name, contactData.selectedFollowupDate, false, false, true)">
            </datetime>
        </div>
        <div v-if="(column.property_name == 'user' && !column.is_custom_field && !column.is_sales_behavior)">
            <select v-model="contactData.selectedUser"
                    @change="inlineUpdate(column.property_name, contactData.selectedUser, false, false, true)"
                    class="appearance-none p-1 border-none focus:outline-none rounded text-grey-darkest text-xs w-full">
                    <option v-for="item in users" :value="item.id">{{ item.name }}</option>
            </select>
        </div>
    </div>
</template>

<script>
    import Multiselect from 'vue-multiselect';
    export default {
        name: 'inline-update',
        components: {Multiselect},
        props: ['column', 'contact', 'contactTypes', 'teamContactStatuses', 'masks', 'calendar', 'users', 'residentialContactType'],
        data() {
            return {
                contactData: {
                    selectedContactType: (this.contact && this.contact.contact_types_id) ? this.contact.contact_types_id : null,
                    selectedContactStatus: (this.contact && this.contact.contact_status) ? this.contact.contact_status : null,
                    customFields: {
                        id: null,
                        type: null,
                        name: null,
                        value: null
                    },
                    salesBehavior: {
                        id: null,
                        name: null,
                        value: null
                    },
                    selectedFollowupDate: (this.contact && this.contact.meeting_followup) ? this.contact.meeting_followup : null,
                    previousFollowupDate: (this.contact && this.contact.meeting_followup) ? this.contact.meeting_followup : null,
                    selectedUser: (this.contact && this.contact.meeting_user) ? this.contact.meeting_user : null
                }
            }
        },
        mounted() {
            let self = this;
            if(self.column.is_custom_field && self.contact && self.contact.custom_field_data && self.contact.custom_field_data.length > 0) {
                _.forEach(self.contact.custom_field_data, function(data) {
                    if(data.id == self.column.custom_field_id) {
                        self.contactData.customFields = {
                            ...data
                        }
                    }
                });
            }
            if(self.column.is_sales_behavior && self.contact && self.contact.sales_behavior_data && self.contact.sales_behavior_data.length > 0) {
                _.forEach(self.contact.sales_behavior_data, function(data) {
                    if(data.id == self.column.sales_behavior_id) {
                        self.contactData.salesBehavior = {
                            ...data
                        }
                    }
                });
            }
        },
        methods: {
            inlineUpdate(field, value, isCustomField = false, isSalesBehavior = false, isMeeting = false) {
                if(isSalesBehavior && this.isDateChanged(field, value)) {
                    this.updateRequest(field, value, isCustomField, isSalesBehavior, isMeeting);
                }
                else if(isMeeting) {
                    let meetingData = this.isValidMeeting(field, value);
                    if(meetingData) {
                        this.updateRequest(field, value, isCustomField, isSalesBehavior, isMeeting, meetingData);
                    }
                }
                else if(!isSalesBehavior && !isMeeting){
                    this.updateRequest(field, value, isCustomField, isSalesBehavior, isMeeting);
                }
            },
            isDateChanged(field, value) {
                let self = this;
                let result = false;
                let dateFormat = '';
                if (self.calendar) {
                    dateFormat = 'MM/DD/yyyy hh:mm:ss a';
                }
                else {
                    dateFormat = 'MM/DD/yyyy';
                }
                if(self.contact.sales_behavior_data.length > 0) {
                    self.contact.sales_behavior_data.forEach((salesBehavior, index)=>{
                        if (salesBehavior.id == field && value.date && value.date != "" && moment(salesBehavior.date).format(dateFormat) !== moment(value.date).format(dateFormat)) {
                            result = true;
                        }
                    });
                }
                return result;
            },
            isValidMeeting(field, value) {
                let self = this;
                let response = null;
                let result = null;
                let msg = '';
                let dateFormat = '';
                self.$emit('inlineUpdateMeetingDataEmit', {contactId: self.contact.id, field: field, value: value}, (res) => response = res);
                if (self.calendar) {
                    dateFormat = 'MM/DD/yyyy hh:mm:ss a';
                }
                else {
                    dateFormat = 'MM/DD/yyyy';
                }
                if (field == 'date' && response.date && response.date != "" && moment(self.contactData.previousFollowupDate).format(dateFormat) !== moment(response.date).format(dateFormat)) {
                    if(response.user) {
                        result = response;
                    }
                    else {
                        msg = 'User is required!';
                        self.getToast(2500).fire({
                            type: 'error',
                            title: msg
                        });
                    }
                }
                else if(field == 'user') {
                    if(response.date && response.date != "") {
                        if(response.user) {
                            result = response;
                        }
                    }
                    else {
                        result = response;
                    }
                }
                return result;
            },
            updateRequest(field, value, isCustomField, isSalesBehavior, isMeeting, meetingData = null) {
                let self = this;
                self.$emit('inlineUpdateLoadingEmit', true);
                let payload = {
                    contact: self.contact,
                    field: field,
                    value: value,
                    isCustomField: isCustomField,
                    isSalesBehavior: isSalesBehavior,
                    isMeeting: isMeeting,
                    meetingData : meetingData
                };
                axios.post(route('api.contact.inline.update'), payload).then((data) => {
                    self.$emit('inlineUpdateLoadingEmit', false);
                    self.getToast(2500).fire({
                        type: data.data.type,
                        title: data.data.msg
                    });
                }).
                catch((error) => {
                    self.$emit('inlineUpdateLoadingEmit', false);
                });
            }
        }
    }
</script>
